/* Tennessee Hills: Co-Packing landing page behavior.
   Loaded (deferred) by the copack-* sections. Everything is progressive:
   the page, links, and forms all work without this file. */
(function () {
  if (window.__copackInit) return;
  window.__copackInit = true;

  var doc = document.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  doc.classList.add('cp-js');

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function fmt(n) { return Math.round(n).toLocaleString('en-US'); }

  /* ---- Reveal on scroll ---- */
  var reveals = $$('.cp-reveal');
  if (!hasIO || reduceMotion) {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var rio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); rio.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -60px 0px', threshold: 0 });
    reveals.forEach(function (el) { rio.observe(el); });
  }

  /* ---- Count-up stats: animates the first number inside [data-cp-count] ---- */
  function countUp(el) {
    var text = el.textContent;
    var m = text.match(/\d[\d,]*(\.\d+)?/);
    if (!m) return;
    var raw = m[0];
    var target = parseFloat(raw.replace(/,/g, ''));
    var decimals = m[1] ? m[1].length - 1 : 0;
    var useComma = raw.indexOf(',') > -1;
    var before = text.slice(0, m.index), after = text.slice(m.index + raw.length);
    var start = null, dur = 1400;
    function frame(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var v = target * eased;
      var s = decimals ? v.toFixed(decimals) : (useComma ? fmt(v) : String(Math.round(v)));
      el.textContent = before + s + after;
      if (p < 1) requestAnimationFrame(frame); else el.textContent = text;
    }
    requestAnimationFrame(frame);
  }
  var counters = $$('[data-cp-count]');
  if (counters.length && hasIO && !reduceMotion) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { countUp(e.target); cio.unobserve(e.target); }
      });
    }, { threshold: 0.6 });
    counters.forEach(function (el) { cio.observe(el); });
  }

  /* ---- Jump to the inquiry form (optionally pre-filling it) ---- */
  function formRoot() { return document.getElementById('copack-inquire'); }
  function goToForm(focusFirst) {
    var root = formRoot();
    if (!root) return false;
    root.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    if (focusFirst) {
      var first = $('input[type="text"]:not(.cp-hp input), input[type="email"]', root);
      if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }, reduceMotion ? 0 : 650);
    }
    return true;
  }
  function checkChip(group, value) {
    var root = formRoot();
    if (!root || !value) return;
    if (group === 'category') {
      var csel = $('select[data-cp-cat-select]', root);
      if (csel) $$('option', csel).forEach(function (o) { if (o.value === value) csel.value = value; });
    }
    $$('[data-cp-chip="' + group + '"]', root).forEach(function (input) {
      if (input.getAttribute('data-value') === value) input.checked = true;
    });
  }
  function setIntent(value) {
    var sel = $('[data-cp-intent-field]', formRoot() || document);
    if (!sel || !value) return;
    if (sel.tagName === 'INPUT') { sel.value = value; return; }
    $$('option', sel).forEach(function (o) { if (o.value === value) sel.value = value; });
  }

  /* ---- Ad attribution: keep utm_* / gclid from the landing URL for the session ---- */
  (function () {
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid'];
    var params = new URLSearchParams(window.location.search);
    keys.forEach(function (k) {
      var v = params.get(k);
      try { if (v) sessionStorage.setItem('cp_' + k, v); else v = sessionStorage.getItem('cp_' + k); } catch (e) {}
      if (!v) return;
      $$('[data-cp-track="' + k + '"]').forEach(function (input) { input.value = v; });
    });
  })();

  document.addEventListener('click', function (e) {
    var cat = e.target.closest('[data-cp-cat]');
    if (cat) {
      e.preventDefault();
      checkChip('category', cat.getAttribute('data-cp-cat'));
      goToForm(true);
      return;
    }
    var link = e.target.closest('a[href="#copack-inquire"], [data-cp-go]');
    if (link) {
      var intent = link.getAttribute('data-cp-intent');
      if (intent) setIntent(intent);
      if (goToForm(true)) e.preventDefault();
    }
  });

  /* ---- Run planner ---- */
  var ML_PER_GAL = 3785.41;
  var FORMATS = {
    can:  { label: '12oz sleek cans', unitMl: 354.88, unit: 'cans', perCase: 24, caseLabel: '24-can cases', perDay: 48000, chip: '12oz cans' },
    glass:{ label: '750ml glass',     unitMl: 750,    unit: 'bottles', perCase: 6, caseLabel: '6-bottle cases', perDay: 12000, chip: '750ml glass' },
    mini: { label: '50ml minis',      unitMl: 50,     unit: 'minis', perCase: 0, caseLabel: '', perDay: 20000, perShift: 8000, chip: '50ml minis' }
  };
  $$('[data-cp-planner]').forEach(function (planner) {
    var range = $('[data-cp-gal]', planner);
    var galOut = $('[data-cp-galval]', planner);
    var tankGal = parseFloat(planner.getAttribute('data-tank-gal')) || 2000;
    var out = {
      units: $('[data-cp-units]', planner), unitLabel: $('[data-cp-unitlabel]', planner),
      cases: $('[data-cp-cases]', planner), caseLabel: $('[data-cp-caselabel]', planner),
      days: $('[data-cp-days]', planner), tanks: $('[data-cp-tanks]', planner),
      summary: $('[data-cp-summary]', planner)
    };
    var state = { fmt: 'can', gal: parseFloat(range.value) || 2000 };

    function calc() {
      var f = FORMATS[state.fmt];
      var units = Math.floor(state.gal * ML_PER_GAL / f.unitMl);
      var cases = f.perCase ? Math.floor(units / f.perCase) : 0;
      var days = units / f.perDay;
      var tanks = Math.max(1, Math.ceil(state.gal / tankGal));
      return { f: f, units: units, cases: cases, days: days, tanks: tanks };
    }
    function daysText(d) {
      if (d <= 0.5) return 'Under ½';
      if (d <= 1) return 'About 1';
      return (Math.round(d * 2) / 2).toLocaleString('en-US');
    }
    function render() {
      var r = calc();
      galOut.textContent = fmt(state.gal);
      out.units.textContent = fmt(r.units);
      out.unitLabel.textContent = r.f.unit + ' filled';
      if (r.f.perCase) { out.cases.textContent = fmt(r.cases); out.caseLabel.textContent = r.f.caseLabel; }
      else { out.cases.textContent = fmt(Math.max(1, Math.ceil(r.units / r.f.perShift))); out.caseLabel.textContent = 'line shifts (~' + fmt(r.f.perShift) + ' per shift)'; }
      out.days.textContent = daysText(r.days);
      out.tanks.textContent = r.tanks + (r.tanks === 1 ? ' tank' : ' tanks');
      out.summary.innerHTML = '<strong>' + fmt(state.gal) + ' gallons</strong> of finished liquid in <strong>' + r.f.label +
        '</strong> is roughly <strong>' + fmt(r.units) + ' ' + r.f.unit + '</strong>. On our line, that’s ' +
        (r.days <= 1 ? 'a single production day.' : 'about ' + daysText(r.days) + ' production days.');
      $$('[data-cp-preset]', planner).forEach(function (b) {
        b.setAttribute('aria-pressed', String(parseFloat(b.getAttribute('data-cp-preset')) === state.gal));
      });
      return r;
    }

    range.addEventListener('input', function () { state.gal = parseFloat(range.value); render(); });
    $$('input[name="cp-plan-fmt"]', planner).forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) { state.fmt = r.value; render(); } });
    });
    $$('[data-cp-preset]', planner).forEach(function (b) {
      b.addEventListener('click', function () {
        state.gal = parseFloat(b.getAttribute('data-cp-preset'));
        range.value = state.gal; render();
      });
    });
    var quote = $('[data-cp-quote-run]', planner);
    if (quote) quote.addEventListener('click', function (e) {
      var r = calc();
      var line = fmt(state.gal) + ' gal in ' + r.f.label + ' (~' + fmt(r.units) + ' ' + r.f.unit +
        (r.f.perCase ? ', ~' + fmt(r.cases) + ' ' + r.f.caseLabel : '') + ')';
      var root = formRoot();
      if (root) {
        var hidden = $('[data-cp-run-field]', root);
        var note = $('[data-cp-run-note]', root);
        if (hidden) hidden.value = line;
        if (note) { note.innerHTML = 'Quoting your run: <strong>' + line + '</strong>'; note.classList.add('is-on'); }
        checkChip('format', r.f.chip);
        setIntent('A production quote');
      }
      if (goToForm(true)) e.preventDefault();
    });
    render();
  });

  /* ---- Sticky mobile CTA: on after the hero, off while the form is on screen ---- */
  var sticky = $('.cp-sticky');
  var hero = $('.cp-hero');
  var form = formRoot();
  if (sticky && hero && hasIO) {
    var pastHero = false, formVisible = false;
    function sync() { sticky.classList.toggle('is-on', pastHero && !formVisible); }
    new IntersectionObserver(function (e) { pastHero = !e[0].isIntersecting; sync(); }, { threshold: 0 }).observe(hero);
    if (form) new IntersectionObserver(function (e) { formVisible = e[0].isIntersecting; sync(); }, { threshold: 0.05 }).observe(form);
  }

  /* ---- Inquiry form: light client-side guard + submit state ---- */
  var inq = document.getElementById('copack-inquiry-form');
  if (inq) inq.addEventListener('submit', function () {
    var btn = $('button[type="submit"]', inq);
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.firstChild && (btn.firstChild.nodeValue = 'Sending… '); }
  });
})();
